import { render, staticRenderFns } from "./ServiceProviderList.vue?vue&type=template&id=0337d850&scoped=true"
import script from "./ServiceProviderList.vue?vue&type=script&lang=js"
export * from "./ServiceProviderList.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderList.vue?vue&type=style&index=0&id=0337d850&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0337d850",
  null
  
)

export default component.exports